import React from "react";
import { useAuth } from "@/contexts/AuthContext";
import { useI18n } from "@/contexts/I18nContext";

export default function Profile() {
  const { user } = useAuth();
  const { t } = useI18n();
  if (!user) return null;

  const fields = [
    { l: t("auth.fullName"), v: user.full_name },
    { l: t("auth.email"), v: user.email },
    { l: t("auth.companyField"), v: user.company || "—" },
    { l: t("auth.countryField"), v: user.country || "—" },
    { l: "Role", v: user.role },
    { l: t("portal.kyc"), v: user.kyc_status },
    { l: "Account opened", v: new Date(user.created_at).toLocaleDateString() },
  ];

  return (
    <div>
      <p className="overline text-muted-foreground">{t("portal.profile")}</p>
      <h1 className="mt-2 font-display text-3xl md:text-4xl font-light tracking-tighter">{user.full_name || user.email}</h1>

      <div className="mt-8 grid grid-cols-1 md:grid-cols-2 gap-px bg-border border border-border max-w-3xl">
        {fields.map(f => (
          <div key={f.l} className="bg-card p-5">
            <p className="overline text-muted-foreground">{f.l}</p>
            <p className="mt-2 font-mono text-[14px] capitalize">{f.v}</p>
          </div>
        ))}
      </div>
    </div>
  );
}
